import React from "react";
import styles from "./managed.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Accordion from "../../../../COMPONENTS/ACCORDION";
import { management, upcoming } from "../../../../CONTENT/physicians";

const Managed = () => (
  <Section tone="light" id="management" labelledBy="management-title">
    <div className={styles.layout}>
      <div className={styles.side}>
        <SectionIntro
          id="management-title"
          eyebrow="Management"
          title="What KUR takes off your plate."
          lead="Once your research program is running, KUR manages the work around each trial so your practice can focus on patient care."
        />
        <aside className={styles.upcoming}>
          <p className={styles.upcomingLabel}>Upcoming</p>
          <p className={styles.upcomingText}>{upcoming}</p>
        </aside>
      </div>
      <Accordion items={management.map((m) => ({ title: m.title, body: <p>{m.text}</p> }))} />
    </div>
  </Section>
);

export default Managed;
